import React from "react";

const DataTable = (props) => {
  const { head, body, style } = props;

  return (
    <table style={style} className="container__table">
      <thead className="container__table__head">
        <tr>
          {head.map((title, i) => (
            <th key={i}>{title}</th>
          ))}
        </tr>
      </thead>
      <tbody className="container__table__body">
        {body && body.map((row, i) => (
          <tr key={i}>
            {row.map((data, i) => (
              <td key={i}>{data}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DataTable;
